/**
 * Generate array with day numbers based on week start
 * @param weekStartsOn week start day
 * @param returnType to return type of format
 * @returns array with days
 */
const getDaysArray = <T extends string | number>(
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6,
  returnType: 'string' | 'number' = 'number',
) => {
  const result = [];

  for (let i = weekStartsOn; i < 7; i++) {
    result.push(returnType === 'string' ? i.toString() : i);
  }

  for (let i = 0; i < weekStartsOn; i++) {
    result.push(returnType === 'string' ? i.toString() : i);
  }

  return result as T[];
};

export default getDaysArray;
